import { SVGProps } from 'react';
import SvgIcon from './SvgIcon';

const MapPin = (props: SVGProps<SVGSVGElement>) => (
  <SvgIcon {...props}>
    <path
      d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"
      stroke="currentColor"
    ></path>
    <circle cx="12" cy="10" r="3" stroke="currentColor"></circle>
  </SvgIcon>
);

export default MapPin;
